<main class="news-page">
  <header class="news-header">
    <div>
      <p class="news-eyebrow">Контент B2C</p>
      <h1>Новости сайта</h1>
      <p class="news-description">Управляйте новостями, которые отображаются в карусели на главной странице.</p>
    </div>
    <button mat-flat-button (click)="createNews()" color="primary" class="add-button">
      <mat-icon>add</mat-icon> Добавить новость
    </button>
  </header>

  <section class="news-summary" *ngIf="!loading && news.length" aria-label="Сводка по публикациям">
    <div><span>Всего</span><strong>{{ count }}</strong></div>
    <div><span class="status-dot status-dot--published"></span><span>Опубликовано</span><strong>{{ publishedCount }}</strong></div>
    <div><span class="status-dot status-dot--draft"></span><span>Черновики</span><strong>{{ draftCount }}</strong></div>
  </section>

  <div class="loading-state" *ngIf="loading">
    <mat-spinner [diameter]="32"></mat-spinner><span>Загружаем новости…</span>
  </div>

  <section class="news-container" *ngIf="!loading && news.length">
    <app-news-card
      *ngFor="let row of news; trackBy: trackByNewsId"
      [news]="row"
      (deleted)="removeNews($event)"
    ></app-news-card>
  </section>

  <section *ngIf="!loading && !news.length" class="empty-state">
    <mat-icon>campaign</mat-icon>
    <h2>Новостей пока нет</h2>
    <p>Создайте первую новость — сначала она сохранится как черновик.</p>
    <button mat-stroked-button color="primary" (click)="createNews()"><mat-icon>add</mat-icon> Создать новость</button>
  </section>
</main>
